import { addNotify } from 'features/notify';

import { ROLE_SUPERADMIN } from 'shared/utils/roleBasedLocale';

const actionTypes = {
  ACTION_PROCESSING: 'promotions/ACTION_PROCESSING',
  SET_POINTS_DATA: 'promotions/SET_POINTS_DATA',
  SUPERADMIN_BONUS_SISTEM_PROCESSING: 'promotions/SUPERADMIN_BONUS_SISTEM_PROCESSING',
  SET_SUPERADMIN_BONUS_SISTEM_DATA: 'promotions/SET_SUPERADMIN_BONUS_SISTEM_DATA',
  SUPERADMIN_BONUS_SISTEM_LOAD_FINISHED: 'promotions/SUPERADMIN_BONUS_SISTEM_LOAD_FINISHED',
};

const getPoints = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.promotions.getPoints();

  if (response.success) {
    dispatch({ type: actionTypes.SET_POINTS_DATA, payload: response.data });
  } else {
    const { locale } = getState().locale;
    const errorMessage = locale[response.codeStatus] ?? (response.errorMessage || locale.defaultMessage);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

const getSuperadminBonusSistem = ({ force = false } = {}) => async (dispatch, getState, extra) => {
  const state = getState();
  const { api } = extra;

  const isSuperadmin = state.auth.role === ROLE_SUPERADMIN;
  const {
    superadminBonusSistemProcessing,
    superadminBonusSistemLoaded,
  } = state.promotions;

  if (!isSuperadmin) return;
  if (superadminBonusSistemProcessing) return;
  if (!force && superadminBonusSistemLoaded) return;

  dispatch({ type: actionTypes.SUPERADMIN_BONUS_SISTEM_LOAD_FINISHED, payload: false });
  dispatch({ type: actionTypes.SUPERADMIN_BONUS_SISTEM_PROCESSING, payload: true });

  try {
    const response = await api.promotions.getSuperadminBonusSistem();

    if (response.success) {
      dispatch({ type: actionTypes.SET_SUPERADMIN_BONUS_SISTEM_DATA, payload: response.data });
    } else {
      const { locale } = getState().locale;
      const errorMessage = locale[response.codeStatus] ?? (response.errorMessage || locale.defaultMessage);
      dispatch(addNotify(errorMessage, 'error'));
    }
  } finally {
    dispatch({ type: actionTypes.SUPERADMIN_BONUS_SISTEM_LOAD_FINISHED, payload: true });
    dispatch({ type: actionTypes.SUPERADMIN_BONUS_SISTEM_PROCESSING, payload: false });
  }
};

export { actionTypes, getPoints, getSuperadminBonusSistem };
